import { Center, Heading, Img, Text, VStack } from '@chakra-ui/react';

import { Button, Link, PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import { ZmyleLinks } from 'utils/paths';

export const IntroductionSection = () => {
  const { content } = usePageTextContent<BenefitsPageContent>();

  const { title, introduction, description, registerButton, pictureUrl } =
    content.introduction;

  return (
    <PageContainer bgGradient="linear(to-r, blue.600, blue.800)" isFullHeight>
      <PageContent
        align="center"
        justify="center"
        direction={['column', 'column', 'row']}
      >
        <VStack
          align={['center', 'center', 'flex-start']}
          spacing="3rem"
          minW="60%"
        >
          <VStack align="flex-start" spacing="1.25rem">
            <Heading color="white" fontSize="1.875rem">
              {title}
            </Heading>

            <Heading color="benefit.secondary" fontSize="2.5rem">
              {introduction}
            </Heading>
          </VStack>

          <Text color="white" fontSize="1.125rem" maxW="35rem">
            {description}
          </Text>

          <Link href={ZmyleLinks.SIGN_UP_COMPANY} isExternal>
            <Button
              variant="benefit"
              borderWidth="2px"
              borderStyle="solid"
              borderColor="white"
            >
              {registerButton}
            </Button>
          </Link>
        </VStack>

        <Center
          w="full"
          maxWidth={['25rem', '25rem', '32rem']}
          my={['2rem', '2rem', 0]}
          display={['none', 'none', 'flex']}
          visibility={['hidden', 'hidden', 'visible']}
        >
          <Img src={pictureUrl} w="full" alt="Benefits Icon" loading="lazy" />
        </Center>
      </PageContent>
    </PageContainer>
  );
};
